import { IconResourceFile, IconDesktop16KindEmail, IconResourceSpace, IconResourceImage, IconResourceFolder, IconResourceHighlight, IconResourceDocument, IconResourceBookmark, IconResourceNotepad, IconResourceVideo, IconResourceAudio } from '@fabric-app/icons/svg';

const resourceIcons = {
  audio: IconResourceAudio,
  video: IconResourceVideo,
  notepad: IconResourceNotepad,
  default: IconResourceFile,
  bookmark: IconResourceBookmark,
  document: IconResourceDocument,
  highlight: IconResourceHighlight,
  folder: IconResourceFolder,
  image: IconResourceImage,
  space: IconResourceSpace,
  email: IconDesktop16KindEmail
};
const getResourceKindIcon = (kind) => {
  return Object.entries(resourceIcons).find(([key]) => key === kind)?.[1] || IconResourceFile;
};

export { getResourceKindIcon };
//# sourceMappingURL=resourceIcons.js.map
